import { render } from "./auth-expired.vue?vue&type=template&id=cee4371e&scoped=true&ts=true"
import script from "./auth-expired.vue?vue&type=script&lang=ts"
export * from "./auth-expired.vue?vue&type=script&lang=ts"

import "./auth-expired.vue?vue&type=style&index=0&id=cee4371e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cee4371e"]])

export default __exports__